import type { ApolloCache } from "@apollo/client";
import { GET_COMPANY_CUSTOM_COLOR_SETTINGS } from "graphql/company";

type ColorSettings = Record<string, unknown>;

interface ColorSettingsData {
  getCompanyCustomColorSettings?: ColorSettings | null;
}

/**
 * Writes saved colour settings over the cached record, for when the re-read
 * after a save failed: the page then follows what was saved instead of the
 * last read. The mutation returns only an id and the query has none, so the
 * cache cannot match them on its own. Leaves a record never read alone.
 */
export const writeSavedColorSettings = (
  cache: ApolloCache<object>,
  saved: ColorSettings,
) => {
  const defined = Object.fromEntries(
    Object.entries(saved).filter(([, value]) => value !== undefined),
  );
  cache.updateQuery<ColorSettingsData>(
    { query: GET_COMPANY_CUSTOM_COLOR_SETTINGS },
    (data) =>
      data?.getCompanyCustomColorSettings
        ? {
            getCompanyCustomColorSettings: {
              ...data.getCompanyCustomColorSettings,
              ...defined,
            },
          }
        : data,
  );
};
